<template>
  <v-form style="height: 100vh; background-color: #111111 !important;">
    <v-overlay :absolute="true" :value="overlayValidation"><v-progress-circular color="primary" :size="70" width="7" indeterminate/></v-overlay>
    <v-container class="login-container" fluid>
      <v-row style="height: 100% !important;">
        <v-col class="pa-12 d-flex align-center" cols="6">
          <v-container class="ml-12" fluid>
            <v-row>
              <v-col cols="10">
                <h1 class="white-content" v-html="$t('title')"></h1>
                <h3 class="mb-3">{{ $t((email.includes('@'))? 'subtitleForEmail' : 'subtitleForUsername', { emailOrUsername: this.email }) }}</h3>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="key" height="100" type="number" class="activation-code" placeholder="000000" outlined dark/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p v-if="!canResendEmail" class="light-grey-content my-0">{{ $t('messagePreEnableBtn', { seconds: secondsBeforeResend }) }}</p>
                <v-btn v-else-if="!sentActivationKey" class="green-button" @click="sendAnotherEmail" dark>{{ $t('sendEmailBtn') }}</v-btn>
                <p v-else class="light-grey-content my-0">{{ $t('messageSentEmail') }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col class="signup-image" cols="6"></v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Repository from '../../../repositories/auth';
import { mapMutations } from "vuex";

export default {
  name: "ConfirmedEmail",
  props: {
    email: String,
    password: String,
  },
  data() {
    return {
      key: '',
      overlayValidation: false,
      secondsBeforeResend: 60,
      canResendEmail: false,
      sentActivationKey: false,
      titleMessage: this.$t('titleMessage1'),
      bodyMessage: this.$t('bodyMessage1'),
    };
  },
  computed: {
    _seconds: () => 1000,
  },
  watch: {
    key() {
      if(String(this.key).length === 6)
        this.validateEmail();
    },
  },
  created() {
    this.setTimerEmailResend();
    if(this.email === undefined)
      this.$router.push('/');
  },
  methods: {
    setTimerEmailResend() {
      let endTime = new Date();
      endTime.setSeconds(endTime.getSeconds() + 61);
      const timer = setInterval(() => {
        let now = new Date();
        let distance = endTime.getTime() - now.getTime();
        if(distance < 1) {
          this.canResendEmail = true;
          clearInterval(timer);
          return;
        }

        this.secondsBeforeResend = Math.floor(distance / this._seconds);
      }, 1000);
    },
    validateEmail() {
      this.overlayValidation = true;
      Repository.confirmedEmail(this.email, this.key).then((response) => {
        this.overlayValidation = false;
        if (response.status < 400) {
          alert(this.$t('successfulActivationMessage'));
          if(this.password !== undefined)
            this.goToDashboard();
          else
            this.goToLogin();
        } else
          alert(this.$t('notSuccessfulActivationMessage'));
      }).catch(() => {
        this.overlayValidation = false;
        alert(this.$t('notSuccessfulActivationMessage'));
      });
    },
    sendAnotherEmail() {
      Repository.requestActivationKey(this.email).then((response) => {
        if(response.status < 400)
          this.sentActivationKey = true;
      });
    },
    ...mapMutations(['setToken', 'setUser', 'setUserDetails', 'setPreferredLanguage']),
    async goToDashboard() {
      this.overlayValidation = true;
      Repository.login(this.email, this.password).then(async (response) => {
        if (response.status < 250) {
          this.setToken(`Bearer ${response.data.id_token}`);
          await Repository.getUser().then((response) => { this.setUser(response.data); });
          await Repository.getLanguage().then((response) => { this.setPreferredLanguage(response.data); });
          await Repository.getUserDetails().then((response) => { this.setUserDetails(response.data); });
          await Repository.analyzeNewUserLogin(this.$store.state.user.id);
          await this.$router.push('/dashboard');
        }
      }).catch((error) => {
        if(error.response.data.status === 401)
          this.goToLogin();
      });
    },
    goToLogin() {
      this.$router.push('/');
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

@import "src/global.scss";

.white-content {
  color: $white-color;
}

.light-grey-content {
  color: $light-gray-color;
}

.v-text-field ::v-deep input {
  font-size: 50px !important;
  max-height: 50px !important;
  text-align: center;
}

.v-input__icon--append .v-icon {
  color: #929292 !important;
  border: none !important;
}

.v-input__icon--append .v-icon:hover {
  color: #929292;
  background-color: rgba(85, 85, 85, 0);
  border: none;
}

.login-container {
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.signup-image {
  padding: 0;
  background-color: #111111;
  background-image: url("https://swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png");
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: right;
}
</style>

<i18n>
{
  "en": {
    "title": "Activate your account",
    "subtitleForEmail": "Verify an activation code in the inbox of {emailOrUsername}. It could have reached spam.",
    "subtitleForUsername": "Verify an activation code in inbox for your username {emailOrUsername}. It could have reached spam.",
    "successfulActivationMessage": "Your account and email were successfully confirmed!",
    "notSuccessfulActivationMessage": "Activation code does not match with your email.",
    "messagePreEnableBtn": "Resend the code in {seconds} seconds",
    "sendEmailBtn": "Resend Code",
    "messageSentEmail": "Activation code was sent! Go to your inbox",
    "titleMessage2": "An error occurred",
    "bodyMessage2": "The user couldn't be activated"
  },
  "es": {
    "title": "Activa tu cuenta",
    "subtitleForEmail": "Verifica en tu correo {emailOrUsername} un código de activación. Puede llegar a spam.",
    "subtitleForUsername": "Verifica un código de activación en tu correo registrado con tu cuenta {emailOrUsername}. Puede llegar a spam.",
    "successfulActivationMessage": "¡Tu email y cuenta han sido confirmados exitosamente!",
    "notSuccessfulActivationMessage": "Código de activación no coincide con tu cuenta.",
    "messagePreEnableBtn": "Puede reenviar el código en {seconds} segundos",
    "sendEmailBtn": "Reenviar Código",
    "messageSentEmail": "¡Código de activación enviado! Revise su correo",
    "titleMessage2": "Ha ocurrido un error",
    "bodyMessage2": "El usuario no pudo ser activado"
  }
}
</i18n>
